import { updateObject } from '@vista-digital/utilities';
import { runInAction } from 'mobx';
import { hasNotification } from '../selectors';
import { getNotifications } from '../selectors/get-notifications';
import { sortNotifications } from '../utils/notification-sort-utils';
import { removeNotification } from './remove-notification';
/**
 * Adds a notification to the temporary notification domain store, if it is
 * not already in it.
 *
 * If a notification with the same unique identifier is already in the store,
 * the given notification will replace it.
 */
export const addNotification = (notification) => {
    // Do not add if already added.
    if (hasNotification(notification.id, notification.messages)) {
        return;
    }
    removeNotification(notification.id);
    notification.addedAt = new Date();
    notification.displayPriority = notification.displayPriority || 0;
    runInAction(() => {
        const notifications = getNotifications();
        notifications.push(notification);
        const sortedNotifications = sortNotifications(notifications);
        updateObject(notifications, sortedNotifications);
    });
};
//# sourceMappingURL=add-notification.js.map